module.exports = __webpack_public_path__ + "static/img/Roboto Slab Regular.59fef7b4.svg";